import {selectCountryCode} from '@/store/slices/countryCodeSlice'
import {COUNTRY_BUSINESS_GROUP_LABELS} from '@/utils/constants/productComboConstants'
import {useMemo, useState} from 'react'
import {useSelector} from 'react-redux'

// Business groups are only available for some markets; hide the tabs/filter otherwise.
export const useProductListBusinessGroupTabs = () => {
  const [selectedTabIndex, setSelectedTabIndex] = useState(0)
  const countryCode = useSelector(selectCountryCode)

  const businessGroupLabels = COUNTRY_BUSINESS_GROUP_LABELS[countryCode]
  const hasBusinessGroups = Boolean(businessGroupLabels)

  const businessGroupTabs = useMemo(
    () => (businessGroupLabels ? Object.entries(businessGroupLabels).map(([id, label]) => ({id, label})) : []),
    [businessGroupLabels]
  )

  const selectedBusinessGroup = hasBusinessGroups ? (businessGroupTabs[selectedTabIndex]?.id ?? null) : null

  return {
    hasBusinessGroups,
    businessGroupTabs,
    selectedTabIndex,
    setSelectedTabIndex,
    selectedBusinessGroup,
  }
}
